import React from "react"
import { Link } from "gatsby"
import { Gallery } from "gatsby-theme-gallery";
import home from "../data/home.json";

import Layout from "../components/layout"
import SEO from "../components/seo"

const SecondPage = () => {
  return (
  <Layout>
    <SEO title="Page two" />
    <h1>Hi from the second page</h1>
    <p>Welcome to page 2</p>
    <Link to="/">Go back to the homepage</Link>
    <Gallery location='content/gallery2'/>
    <h1>Jeff is still cool</h1>
    {home.sort((a, b)=>  {
  const nameA = a.Name.toUpperCase();
  const nameB = b.Name.toUpperCase();

  let comparison = 0;
  if (nameA > nameB) {
    comparison = 1;
  } else if (nameA < nameB) {
    comparison = -1;
  }
  return comparison; }).map((person) => <p>{person.Name}</p>)}
  </Layout>);
}

export default SecondPage
